import { render, staticRenderFns } from "./IndicadorRentabilidadNeta.vue?vue&type=template&id=782a5770&"
import script from "./IndicadorRentabilidadNeta.vue?vue&type=script&lang=js&"
export * from "./IndicadorRentabilidadNeta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports